import React from 'react'
import { Grid } from "@mui/material"

import {
	AnalyzerEvolutionModal,
	AnalyzersTable,
	MarketBandChart,
	PositionContext,
	PositionKpis,
	PositionVerdict,
	RankEvolutionChart,
	AnalyzerTableState,
} from "Pages/AnalyzersV2/@components"
import { UpdatingVeil } from "Pages/AnalyzersV2/@components/CarPick/TableState"
import { analyzerCarPick, isAnalyzerLoading, responseData } from "Pages/AnalyzersV2/@signals"
import { pickOn } from "Pages/AnalyzersV2/@services/carPick"
import { useAnalyzerPositionFilters } from "Pages/AnalyzersV2/Position/@hooks"
import useAnalyzerData from "Pages/AnalyzersV2/@hooks/useData"
import { sortRowsByAveragePrice } from "Pages/AnalyzersV2/@components/Table/@utils"
import { findCurrency, findMainName } from "Pages/AnalyzersV2/Position/@utils"
import { NoDataFound, AppResultsSkeleton } from "@components"


export default function PositionContent() {
	const {
		tableData,
		tableColumns,
		dataEmpty,
		evolutionData,
		chartContent,
		noResults,
		mainData,
		marketChartData
	} = useAnalyzerData(responseData.value)
	const { onSubmit } = useAnalyzerPositionFilters()

	// the Cars selector (CU-869fmpqfm): a car picked asks again without Search; the KPIs, verdict and charts above the
	// table follow it, so they stay under the same "Updating…" veil
	const onPick = pick => {
		analyzerCarPick.value = pick
		onSubmit(false, { keep: true })
	}

	// no prices with a car picked: the card stays, with the field and why (decision 2, UX Obs. 1)
	if (noResults && pickOn(analyzerCarPick.value) && !isAnalyzerLoading.value) {
		return <AnalyzerTableState noResults onPick={onPick} isPosition/>
	}

	if (noResults) {
		return <NoDataFound/>
	}

	if (dataEmpty && !isAnalyzerLoading.value) return null

	const mainName = findMainName(tableData)
	const currency = findCurrency(tableData)
	const totalBrands = mainData?.avgMarketRank?.lenCompetitors || chartContent.keySeries?.length
	// Table only — charts and Excel keep the backend's alphabetical order.
	const sortedTableData = sortRowsByAveragePrice(tableData)

	return <UpdatingVeil><Grid container spacing={2}>
		<Grid item xs={12}>
			<PositionContext
				mainName={mainName}
				office={chartContent.officeData}
				columns={tableColumns}
				totalBrands={totalBrands}
				currency={currency}
			/>
		</Grid>
		<Grid item xs={12}>
			<PositionKpis mainData={mainData} currency={currency}/>
		</Grid>
		<Grid item xs={12}>
			<PositionVerdict mainData={mainData} mainName={mainName}/>
		</Grid>
		<Grid item xs={12}>
			<MarketBandChart
				marketChartData={marketChartData}
				totalBrands={totalBrands}
			/>
		</Grid>
		<Grid item xs={12}>
			<RankEvolutionChart
				chartData={chartContent.chartData}
				keySeries={chartContent.keySeries}
			/>
		</Grid>
		<Grid item xs={12}>
			{isAnalyzerLoading.value && <AppResultsSkeleton rows={7} columns={8}/>}
			{!isAnalyzerLoading.value && <AnalyzerTableState noResults={noResults} onPick={onPick} isPosition veil={false}>
				<AnalyzersTable
					tableData={sortedTableData}
					columns={tableColumns}
					evolutionData={evolutionData}
					isPosition
					mainName={mainName}
					// Broker mode groups rows by provider, not by web, so the site
					// favicon would not describe the row. Read from the response and
					// not from the signal: flipping the toggle does not refetch, and
					// the loaded rows still belong to the previous mode.
					hideIcon={!!responseData.value?.isProviderMode}
					carPick={{ onPick }}
				/>
			</AnalyzerTableState>}
		</Grid>
		<Grid item xs={12}>
			<AnalyzerEvolutionModal/>
		</Grid>
	</Grid></UpdatingVeil>
}
